module.exports = __webpack_public_path__ + "static/media/3_col_1.8eed414c.jpg";